import { HeaderSide } from "./headerside"
import style from './style.module.css'
import { MapWithPoligons } from "../../MapWithPoligons";
import { Table } from "./Table";
import { Graph1 } from "./graph1";
import { Graph2 } from "./graph2";
import L from "leaflet";

const customMarkerIcon = L.icon({
    iconUrl: "/imort.svg",
    iconSize: [35, 55],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });


const staticMarker = [
    {
        latitude: 42.8746,
        longitude: 74.5698,
        name: "ОсОО «Кыргыз Мясопродукт»",
        popupContent: `
          <div style="font-family: Montserrat, Arial, sans-serif; max-width: 320px;">
            <div style="font-size: 20px; font-weight: 600; margin-bottom: 12px;">Карточка потребностей</div>
            <div style="margin-bottom: 8px;"><b>Продукт :</b>Молоко</div>
            <div style="margin-bottom: 8px;"><b>Год:</b> 2024 год</div>
            <div style="margin-bottom: 8px;"><b>Регион:</b> <span">ОШ</span></div>
            <hr style="margin: 10px 0;">
            <div style="margin-bottom: 8px;"><b>Среднедушевое потребление :</b> 240 кг</div>
            <div style="margin-bottom: 8px;"><b>Население : </b> 1 100 000 чел</div>
            <hr style="margin: 10px 0;">
            <div style="margin-bottom: 8px;"><b>Общее потребление :</b> 260 тонн</div>
          </div>
        `
      }
];


export const Needsofthepopulation = () => {
    return (
        <div>
            <HeaderSide />
            <div className={style.container}>
            <div className={style.map}>
            <MapWithPoligons
                latitude={41.5089324}
                longitude={74.724091}
                    type={["REGION"]}
                    extraData={staticMarker}
                    customIcon={customMarkerIcon}
                />
                <Table />
                </div>
            </div>
            <div className={style.graphs}>
        <div className={style.graph1}>
            <Graph1 />
        </div>
        <div className={style.graph2}>
            <Graph2 />
        </div>
        </div>
        </div>
    )
}       